import { CacheProvider, EmotionCache } from '@emotion/react';
import CssBaseline from '@mui/material/CssBaseline';
import { Experimental_CssVarsProvider as CssVarsProvider } from '@mui/material/styles';
import { FC, ReactNode } from 'react';
import { LicenseInfo } from '@mui/x-data-grid-pro';

import { LocalizationProvider } from '~ui-components/providers/localization-provider';
import { Rtl } from '~ui-components/components/atoms/rtl';
import {
	SettingsConsumer,
	SettingsProvider,
} from '~ui-components/contexts/settings';
import { createTheme } from '~ui-components/theme/create-theme';

LicenseInfo.setLicenseKey(
	'54b15a57982fcfd357f997b69b2e34f7T1JERVI6Mzk0NzQsRVhQSVJZPTE2Nzg2MTEzNDAwMDAsS0VZVkVSU0lPTj0x'
);

export type UiProviderProps = {
	emotionCache: EmotionCache;
	children: ReactNode;
};
export const UiProvider: FC<UiProviderProps> = ({ emotionCache, children }) => (
	<CacheProvider value={emotionCache}>
		<LocalizationProvider>
			<SettingsProvider>
				<SettingsConsumer>
					{(settings) => {
						const theme = createTheme({
							primaryColor: settings.primaryColor,
							colorScheme: settings.colorScheme,
							direction: settings.direction,
						});

						return (
							<CssVarsProvider
								defaultColorScheme={settings.colorScheme}
								defaultMode={settings.colorScheme}
								theme={theme}
							>
								<CssBaseline />
								<Rtl direction={settings.direction}>{children}</Rtl>
							</CssVarsProvider>
						);
					}}
				</SettingsConsumer>
			</SettingsProvider>
		</LocalizationProvider>
	</CacheProvider>
);
